import React from 'react';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './Contact.scss';

const Submit = () => {
    const navigate = useNavigate();

    return (
        <div className="contact-page">
            <Navbar />
            <div className="contact-section">
                <div className="contact-container">
                    <div className="success-message">
                        <div className="success-icon">
                            <FaCheckCircle />
                        </div>
                        <h2>Thank You for Contacting Us!</h2>
                        <p className="success-text">We have received your message and will get back to you within 12 hours.</p>
                        <div className="next-steps">
                            <h3>What's Next?</h3>
                            <ul>
                                <li>Our team will review your requirements</li>
                                <li>We'll contact you to discuss your project in detail</li>
                                <li>We'll provide a customized solution proposal</li>
                            </ul>
                        </div>
                        <div className="contact-info">
                            <p>For urgent inquiries, please email us</p>
                            <a href="mailto:connorxiong.ai@gmail.com" className="email-link">
                                <FaEnvelope /> connorxiong.ai@gmail.com
                            </a>
                        </div>
                        <button 
                            className="test-button"
                            onClick={() => navigate('/contact')}
                        >
                            Back to Form
                        </button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Submit; 